import React from 'react';
import { PrimaryButton } from './PrimaryButton';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon: React.ReactNode;
  heading: string;
  body: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({
  icon,
  heading,
  body,
  action,
}: EmptyStateProps): React.ReactElement {
  return (
    <div className={styles.container} data-testid="empty-state">
      <div className={styles.iconWrap} aria-hidden="true">
        {icon}
      </div>
      <h2 className={styles.heading} data-testid="empty-state-heading">
        {heading}
      </h2>
      <p className={styles.body} data-testid="empty-state-body">
        {body}
      </p>
      {action !== undefined && (
        <PrimaryButton
          onClick={action.onClick}
          data-testid="empty-state-action"
          style={{ marginTop: 'var(--space-2)' }}
        >
          {action.label}
        </PrimaryButton>
      )}
    </div>
  );
}
